import { Layout, Showcase, Grid, GridItem, UseCase, Header, SectionTitle } from "../../../../src/components";
import { FaCheck, FaTimes } from 'react-icons/fa';
import "../../../../src/pages/wt/components/(deprecated) button-small/style.scss";
import data from "../../../../src/pages/wt/components/(deprecated) button-small/data.json";
import changelog from "../../../../src/data/changelog.json";
import * as React from 'react';
export default {
  Layout,
  Showcase,
  Grid,
  GridItem,
  UseCase,
  Header,
  SectionTitle,
  FaCheck,
  FaTimes,
  data,
  changelog,
  React
};